<template>
  <scoped>
    <VerticalNavigator>
      <Breadcrumb
        :links="[{
          title: 'RutSolve',
          routeName: 'index'
        }, {
          title: 'Suppliers',
          routeName: 'suppliers'
        }]"
        title="Create"
      />
      <h1>
        Create Supplier
      </h1>
      <SupplierEditor v-model:value="supplier" />
      <h2>
        Contact Details
      </h2>
      <ContactDetailsList
        v-if="supplier.contactDetails"
        v-model:items="supplier.contactDetails.records"
        v-model:selectedIndex="selectedContactDetailsIndex"
        @select="selectedContactDetails = supplier.contactDetails.records[selectedContactDetailsIndex]"
      />
      <ContentModal v-if="selectedContactDetails">
        <ContactDetailsEditor v-model:value="selectedContactDetails" />
        <br>
        <Button
          title="Apply"
          @click="selectedContactDetails = null"
        />
      </ContentModal>
      <Button
        title="Cancel"
        @click="supplierRedirect()"
      />
      <Button
        title="Save"
        @click="save()"
      />
    </VerticalNavigator>
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import Button from "@/components/button.vue"
  import SupplierEditor from "@/components/editors/supplier.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {Supplier as SupplierResolver} from "@/endpoints/rutsolve/gql/resolvers/supplier"
  import {ContactDetails as ContactDetailsResolver} from "@/endpoints/rutsolve/gql/resolvers/contact_details"
  import {ref} from "vue"
  import {
    ContactDetails,
    Supplier,
  } from "@/endpoints/rutsolve/gql/generated/graphql"
  import router from "@/router"
  import ErrorModal from "@/components/modals/error.vue"
  import ContactDetailsList from "@/components/lists/contact_details.vue"
  import ContactDetailsEditor from "@/components/editors/contact_details.vue"
  import ContentModal from "@/components/modals/content.vue"

  const error = ref<Error>(null)
  const supplierResolver = new SupplierResolver()
  const contactDetailsResolver = new ContactDetailsResolver()
  const selectedContactDetails = ref<ContactDetails>(null)
  const selectedContactDetailsIndex = ref<number>(null)
  const supplier = ref<Supplier>({
    contactDetails: {
      records: [],
    }
  })

  async function save() {
    try {
      const supplierID = await supplierResolver.create(supplier.value)
      if (supplier.value.contactDetails && supplier.value.contactDetails.records) {
        for (const contactDetails of supplier.value.contactDetails.records) {
          if (contactDetails.deletedAt) {
            continue
          }
          contactDetails.relationID = supplierID
          contactDetails.relationType = "SUPPLIER"
          await contactDetailsResolver.create(contactDetails)
        }
      }
      supplierRedirect()
    } catch(e) {
      error.value = e
    }
  }

  function supplierRedirect() {
    router.push({
      name: "suppliers"
    })
  }
</script>
